import type { FaireProductEntity } from "../../entity_types/product";

export const p_tvw6k5tu3a: FaireProductEntity = {
  token: "p_tvw6k5tu3a",
  type: "product",
  name: "Crushed It Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9d87cb7a00413ffb2d70b40ddf0b7dbf1494316143d31e160111a376c6646536.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7ca231076c47477d6a8f140b53479db089626b980384e2f477c07b49bd15b61.jpeg",
    "https://cdn.faire.com/fastly/e8abbd3333fd17006b27568a015868b51e6c4189e93ff25de468bd0e39323936.png",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:18.034Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
